import * as t from 'io-ts';
import { ImageDynamicType } from './image';

export const BrokerShortDetailsDynamicType = t.interface({
    fullname: t.string,
    email: t.string,
    mobile: t.union([t.string, t.null]),
    landline:  t.union([t.string, t.null]),
    office24HrNumber: t.union([t.string, t.null])
});

export const BrokerDetailsDynamicType = t.intersection([
    BrokerShortDetailsDynamicType,
    t.interface({
        image: t.union([ImageDynamicType, t.null])
    })
]);

export const AllBrokerDetailsDynamicType = t.interface({
    primaryBroker: t.union([BrokerDetailsDynamicType, t.null]),
    otherBrokers: t.array(BrokerDetailsDynamicType)
});

export type BrokerShortDetails = t.TypeOf<typeof BrokerShortDetailsDynamicType>;
export type BrokerDetails = t.TypeOf<typeof BrokerDetailsDynamicType>;
export type AllBrokerDetails = t.TypeOf<typeof AllBrokerDetailsDynamicType>;
